import Router from '@/router/index'
import Routes from '@/router/routes'

import api from '@/api/api'
import i18n from '@/locales/i18n'
import HTTP from '@/components/general/http/http'

export default {
	data : null,
	logout () {	

		let headerToDelete = {
			key : 'x-parse-session-token'
		}

		api
			.authentication
			.logout()
			.then( (response) => {

				HTTP.deleteHeader(headerToDelete)
				localStorage.removeItem('sessionToken')
				localStorage.removeItem('sessionUser')
				
				window.location.href = Routes.login.path

				return
				
			});

	},
	fetchSession () {

		let vm = this

		return api
			.authentication
			.session()
			.then( (response) => {

				if( response.status != 200 ){

					let message = {
						message : [i18n.t('errors.custom.001')],
						type    : 'error'
					}

					vm.$root.$emit('showMessage', message)

					return {
						success : false
					}

				}

				if( !response.data.success ){

					let message = {
						message : [i18n.t('errors.custom.001')],
						type    : 'error'
					}

					vm.$root.$emit('showMessage', message)

					return {
						success : false
					}

				}

				vm.data = response.data.session

				delete vm.data.sessionToken

				return {
					success : true
				}

			})

	}
}



// WEBPACK FOOTER //
// ./src/components/general/session/session.js